/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransitionalClientTeamResource
 */
export interface TransitionalClientTeamResource {
    /**
     * 
     * @type {string}
     * @memberof TransitionalClientTeamResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionalClientTeamResource
     */
    name?: string;
}

/**
 * Check if a given object implements the TransitionalClientTeamResource interface.
 */
export function instanceOfTransitionalClientTeamResource(value: object): value is TransitionalClientTeamResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TransitionalClientTeamResourceFromJSON(json: any): TransitionalClientTeamResource {
    return TransitionalClientTeamResourceFromJSONTyped(json, false);
}

export function TransitionalClientTeamResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransitionalClientTeamResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function TransitionalClientTeamResourceToJSON(value?: TransitionalClientTeamResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

